import React, {AllHTMLAttributes, FC, PropsWithChildren} from "react";
import './MainGrid.scoped.scss';
import {cn} from "../../../utils";

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const MainGrid: FC<PropsWithChildren<Props>> = ({children, ...props}) => {
  return (
    <div {...props} className={cn("main-grid", props.className)}>
      { children }
    </div>
  );
};

export default MainGrid;